/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q2_AInputs */

const en_consult_q2_a = /** @type {(inputs: Consult_Q2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under $1,000`)
};

const id_consult_q2_a = /** @type {(inputs: Consult_Q2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di bawah Rp10 juta`)
};

/**
* | output |
* | --- |
* | "Under $1,000" |
*
* @param {Consult_Q2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q2_a = /** @type {((inputs?: Consult_Q2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q2_a(inputs)
	return en_consult_q2_a(inputs)
});